import React from "react";

const features = [
  {
    src: "https://images.schooglink.com/image/website/presence.png",
    value: "4",
    label: "STATES",
  },
  {
    src: "https://images.schooglink.com/image/website/smart_classroom.png",
    value: "120",
    label: "SMART CLASSROOMS",
  },
  {
    src: "https://images.schooglink.com/image/website/students.png",
    value: "50,000+",
    label: "CLASSROOM STUDENTS",
  },
  {
    src: "https://images.schooglink.com/image/website/app_downloads.png",
    value: "8,00,000+",
    label: "APP DOWNLOADS",
  },
  {
    src: "https://images.schooglink.com/image/website/curriculum.png",
    value: "23",
    label: "CURRICULUM",
  },
  {
    src: "https://images.schooglink.com/image/website/vernacular_medium.png",
    value: "3",
    label: "VERNACULAR MEDIUM",
  },
];

const Features = () => {
  return (
    <section className="pt-20 sm:pt-24 lg:pt-32 w-full max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 className="text-center text-2xl sm:text-3xl lg:text-4xl font-extrabold mb-10 sm:mb-12 text-gray-900">
        Our Reach & Impact
      </h2>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-6 sm:gap-8 lg:gap-10 text-center">
        {features.map((f, idx) => (
          <div
            key={idx}
            className="flex flex-col items-center justify-center transition-transform duration-300 hover:scale-105"
          >
            <img
              src={f.src}
              alt={f.label}
              loading="lazy"
              className="h-14 sm:h-20 lg:h-24 object-contain drop-shadow-md"
            />
            <p className="mt-3 text-base sm:text-lg lg:text-2xl font-bold text-gray-900">
              {f.value}
            </p>
            <p className="text-xs sm:text-sm md:text-base text-gray-700 font-medium mt-1">
              {f.label}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Features;
